module.exports = __webpack_public_path__ + "static/img/PH@2x.a8c71434.jpg";